module.exports = __webpack_public_path__ + "static/img/topic-finish.0720cc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/topic-finish.png
// module id = hc4t
// module chunks = 52